module.exports = __webpack_public_path__ + "static/knowOurTeam-ce9c5d7b5ccf51e695483140d236fc54.png";